import React from 'react';
import {
    Flex, Text, Image, Button
} from 'components/ui';
import { wrapFunctionalComponent } from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import Location from 'utils/Location';
import { space } from 'style/config';
import cookieUtils from 'utils/Cookies';
import { SSS_LINK, SSS_INTERNAL_CAMPAIGN } from 'constants/smartSkinScan';
import anaUtils from 'analytics/utils';

import SmartSkinScanEN from 'components/Catalog/ProductGrid/SmartSkinScanBanner/locales/SmartSkinScan_en_US';
import SmartSkinScanFR from 'components/Catalog/ProductGrid/SmartSkinScanBanner/locales/SmartSkinScan_fr_CA';

const { getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(SmartSkinScanEN, SmartSkinScanFR);

const SSS_ICON_SRC = '/img/ufe/smartSkinScan.png';

function SmartSkinScanBanner() {
    const isIllinoisUser = cookieUtils.read(cookieUtils.KEYS.ILLINOIS_YES) === 'true';

    if (isIllinoisUser) {
        return null;
    }

    const handleClick = e => {
        anaUtils.setNextPageData({
            internalCampaign: SSS_INTERNAL_CAMPAIGN
        });
        Location.navigateTo(e, SSS_LINK);
    };

    const handleKeyDown = e => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick(e);
        }
    };

    return (
        <Flex
            alignItems='center'
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            css={styles.container}
            role='link'
            tabIndex={0}
            aria-label={getText('title')}
            data-at={Sephora.debug.dataAt('smart_skin_scan_banner')}
        >
            <Image
                disableLazyLoad={true}
                src={SSS_ICON_SRC}
                alt=''
                css={styles.icon}
            />
            <Flex
                flexDirection='column'
                flex={1}
            >
                <Text
                    fontWeight='bold'
                    fontSize='md'
                    color='black'
                    lineHeight='tight'
                >
                    {getText('title')}
                </Text>
                <Text
                    fontSize='sm'
                    color='black'
                    lineHeight='tight'
                >
                    {getText('subtitle')}
                </Text>
            </Flex>
            <Button
                variant='primary'
                size='sm'
                css={styles.button}
                tabIndex={-1}
            >
                {getText('tryNow')}
            </Button>
        </Flex>
    );
}

const styles = {
    container: {
        width: '100%',
        height: 80,
        padding: space[4],
        gap: space[3],
        background: 'linear-gradient(90deg, #F4E7FF 0%, #CABBDE 100%)',
        cursor: 'pointer',
        textDecoration: 'none'
    },
    icon: {
        width: 32,
        height: 32,
        flexShrink: 0
    },
    button: {
        borderRadius: 100,
        flexShrink: 0,
        pointerEvents: 'none',
        minWidth: 93
    }
};

export default wrapFunctionalComponent(SmartSkinScanBanner, 'SmartSkinScanBanner');
